export const getUser = (state) => state.auth.user;
export const getToken = (state) => state.auth.token;
export const getMessages = (state) => state.global.messages;
export const getChats = (state) => state.global.chats;
export const getConsults = (state) => state.global.consultAllChats;
